(() => {
  'use strict';
  const dialog = document.getElementById('DrapeurFavorites');
  if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
  dialog.dataset.ready = 'true';
  const key = 'drapeur:favorites:v1';
  const strings = dialog.dataset;
  const list = dialog.querySelector('[data-favorites-list]');
  const status = dialog.querySelector('[data-favorites-status]');
  const retry = dialog.querySelector('[data-favorites-retry]');
  const loading = dialog.querySelector('[data-favorites-loading]');
  const empty = dialog.querySelector('[data-favorites-empty]');
  const announcement = document.querySelector('[data-favorites-announcement]');
  const root = strings.root.replace(/\/?$/, '/');
  let favorites = [];
  let generation = 0;
  const failedHandles = new Set();
  function syncRetry() {
    const failed = favorites.some(handle => failedHandles.has(handle));
    retry.hidden = !failed;
    if (!failed && status.textContent === strings.loadError) status.textContent = "";
  }
  let opener;
  let storageWorks = true;
  const clean = value => Array.isArray(value) ? [...new Set(value.filter(h => typeof h === 'string' && h.length > 0 && h.length <= 255 && !/[\s/?#\\]/.test(h)))].slice(0, 500) : [];
  function read() {
    try {
      const raw = localStorage.getItem(key);
      try { return clean(raw ? JSON.parse(raw) : []); } catch (_) { return []; }
    } catch (_) { storageWorks = false; return favorites; }
  }
  favorites = read();
  function announce(message) {
    announcement.textContent = message;
    if (dialog.open) status.textContent = message;
  }
  function sync(scope = document) {
    scope.querySelectorAll('[data-favorite-handle]').forEach(button => {
      const selected = favorites.includes(button.dataset.favoriteHandle);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', (selected ? strings.remove : strings.add) + ' — ' + button.dataset.favoriteTitle);
    });
    document.querySelectorAll('[data-favorites-open]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-favorites-count]').forEach(counter => {
      counter.textContent = favorites.length ? String(favorites.length) : '';
    });
  }
  function toggle(button) {
    if (storageWorks) favorites = read();
    const handle = button.dataset.favoriteHandle;
    const removed = favorites.includes(handle);
    favorites = removed ? favorites.filter(h => h !== handle) : clean([...favorites, handle]);
    try {
      localStorage.setItem(key, JSON.stringify(favorites));
      storageWorks = true;
    } catch (_) { storageWorks = false; }
    sync();
    const message = storageWorks ? (removed ? strings.removed : strings.added) : strings.storageError;
    announce(message);
    if (dialog.open) {
      if (removed) {
        const card = [...list.children].find(el => el.dataset.handle === handle);
        const target = card?.nextElementSibling?.querySelector('button') || card?.previousElementSibling?.querySelector('button') || dialog.querySelector('[data-favorites-close]');
        const restore = card?.contains(document.activeElement);
        card?.remove();
        failedHandles.delete(handle);
        syncRetry();
        empty.hidden = favorites.length > 0;
        if (restore) target.focus();
      } else render();
    }
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function removeButton(handle, title) {
    const button = element('button', 'drapeur-favorite drapeur-favorite--card');
    button.type = 'button';
    button.dataset.favoriteHandle = handle;
    button.dataset.favoriteTitle = title;
    const icon = document.querySelector('[data-favorites-open] .drapeur-heart');
    if (icon) button.append(icon.cloneNode(true));
    return button;
  }
  function money(cents) {
    return new Intl.NumberFormat(strings.locale, {style: 'currency', currency: window.Shopify?.currency?.active || strings.currency || 'EUR'}).format(cents / 100);
  }
  function fillCard(card, handle, product, missing) {
    const title = product?.title || handle.replace(/-/g, ' ');
    card.replaceChildren();
    if (product) {
      const link = element('a', '');
      link.href = root + 'products/' + encodeURIComponent(handle);
      const image = element('img', 'drapeur-favorites__image');
      if (product.featured_image) {
        const source = new URL(product.featured_image, location.origin);
        if (source.protocol === 'https:' || source.protocol === 'http:') {
          source.searchParams.set('width', '540');
          image.src = source.href;
          image.alt = '';
          image.width = 540;
          image.height = 720;
          image.loading = 'lazy';
          link.append(image);
        }
      } else link.append(element('div', 'drapeur-favorites__image'));
      link.append(element('div', 'drapeur-favorites__vendor', product.vendor || ''), element('span', 'drapeur-favorites__name', title));
      link.append(element('span', 'drapeur-favorites__price', (product.price_varies ? strings.from + ' ' : '') + money(product.price)));
      if (!product.available) link.append(element('span', 'drapeur-favorites__availability', strings.soldOut));
      card.append(link);
    } else {
      card.append(element('div', 'drapeur-favorites__missing', title), element('p', 'drapeur-favorites__availability', missing ? strings.unavailable : strings.loadError));
    }
    card.append(removeButton(handle, title));
    sync(card);
  }
  async function render() {
    const current = ++generation;
    const handles = [...favorites];
    list.replaceChildren();
    status.textContent = storageWorks ? '' : strings.storageError;
    failedHandles.clear();
    retry.hidden = true;
    empty.hidden = handles.length > 0;
    loading.hidden = handles.length === 0;
    const jobs = handles.map(handle => {
      const card = element('li', 'drapeur-favorites__item');
      card.dataset.handle = handle;
      list.append(card);
      return {handle, card};
    });
    async function worker() {
      while (jobs.length && current === generation) {
        const {handle, card} = jobs.shift();
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {signal: controller.signal, credentials: 'same-origin'});
          if (response.status === 404) {
            if (current === generation) fillCard(card, handle, null, true);
          } else {
            if (!response.ok) throw new Error('Product request failed');
            const product = await response.json();
            if (typeof product.title !== 'string' || !Number.isFinite(product.price)) throw new Error('Invalid product');
            if (current === generation) fillCard(card, handle, product, false);
          }
        } catch (_) {
          if (current === generation && favorites.includes(handle)) failedHandles.add(handle);
          if (current === generation) fillCard(card, handle, null, false);
        } finally { clearTimeout(timeout); }
      }
    }
    await Promise.all(Array.from({length: Math.min(4, jobs.length)}, worker));
    if (current !== generation) return;
    loading.hidden = true;
    syncRetry();
    if (!retry.hidden) status.textContent = strings.loadError;
  }
  document.addEventListener('click', event => {
    const favorite = event.target.closest('[data-favorite-handle]');
    if (favorite) {
      event.preventDefault();
      event.stopPropagation();
      toggle(favorite);
      return;
    }
    const trigger = event.target.closest('[data-favorites-open]');
    if (trigger) {
      opener = trigger;
      favorites = read();
      sync();
      dialog.showModal();
      document.documentElement.classList.add('drapeur-favorites-open');
      render();
    }
    if (event.target.closest('[data-favorites-close]')) dialog.close();
    if (event.target.closest('[data-favorites-retry]')) render();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    generation++;
    document.documentElement.classList.remove('drapeur-favorites-open');
    opener?.focus();
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    favorites = read();
    sync();
    if (dialog.open) render();
  });
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-favorite-handle], [data-favorites-open]') || node.querySelector('[data-favorite-handle], [data-favorites-open]'))))) sync();
  }).observe(document.body, {childList: true, subtree: true});
  sync();
})();
